module.exports = __webpack_public_path__ + "img/ok2.4fe35614.png";